import { createSelector } from "@reduxjs/toolkit";
import _ from "lodash";

export const selectShoppingCartCountPerArticleId = createSelector([(state) => state.shoppingCart.items], (items) => {
  return _.chain(items)
    .groupBy("article.id")
    .mapValues((group) => _.sumBy(group, "count"))
    .value();
});
